import { useState, useEffect, createRef } from 'react'
import '../styles/stage-intro.scss'

const StageIntro = ({ step, progress }) => {
  const circleRef = createRef()
  const [circleLength, setCircleLength] = useState()

  useEffect(() => {
    if (step >= 4) {
      setCircleLength(circleRef.current.getTotalLength())
      //console.log('length', circleRef.current.getTotalLength())
    }
  }, [circleRef, step])

  const CIRCLE_PERCENT = {
    Clarity: 0.66,
    Alignment: 0.043,
    Search: 0.129,
    Advance: 0.168
  }

  const LABELS = ['Clarity', 'Alignment', 'Search', 'Advance']
  return (
    <figure className={`intro step-${step}`}>
      {/* The current triggered step index is: {step} */}
      <>
        <div
          className={`gradient-1 step-${step}`}
          style={
            step === 2
              ? {
                  background: `radial-gradient(circle at bottom, #6189de ${
                    progress * 50
                  }%, #000e29)`
                }
              : null
            // : step === 5
            // ? {
            //     background: `radial-gradient(circle at bottom, #6189de ${
            //       50 - progress * 50
            //     }%, #000e29)`
            //   }
            // : null
          }
        />
        {step <= 4 && (
          <>
            <div className={`circle circle-1 step-${step}`}></div>
            <div className={`circle circle-2 step-${step}`}></div>
            <div className={`circle circle-3 step-${step}`}></div>
            <div className={`circle circle-4 step-${step}`}></div>
            <div className={`circle circle-5 step-${step}`}></div>
            <div className={`circle circle-6 step-${step}`}></div>
            <div className={`circle circle-7 step-${step}`}></div>
            <div className={`circle circle-8 step-${step}`}></div>
          </>
        )}
        {step >= 2 && (
          <svg className="intro">
            <filter id="inset-shadow">
              <feOffset dx="1" dy="4" />

              <feGaussianBlur stdDeviation="7" result="offset-blur" />

              <feComposite
                operator="out"
                in="SourceGraphic"
                in2="offset-blur"
                result="inverse"
              />

              <feFlood floodColor="black" floodOpacity=".5" result="color" />
              <feComposite
                operator="in"
                in="color"
                in2="inverse"
                result="shadow"
              />

              <feComposite operator="over" in="shadow" in2="SourceGraphic" />
            </filter>
            <g className={`row-of-circles step-${step}`}>
              {[1, 2, 3, 4].map((num) => (
                <circle
                  key={num}
                  className={`circle-row-${num} step-${step} shadow`}
                  cx="0"
                  cy="0"
                  r="8vw"
                ></circle>
              ))}
            </g>
            {step >= 3 && (
              <>
                <g className={`circle-strokes step-${step}`}>
                  {LABELS.map((label, i) => (
                    <circle
                      key={`${label}`}
                      className={`circle-stroke stroke-${i + 1} step-${step}`}
                      cx="0"
                      cy="0"
                      r="7.25vw"
                      ref={circleRef} //only need ref on one of them b/c size is same for all
                      strokeDasharray={circleLength}
                      strokeDashoffset={
                        step >= 5
                          ? circleLength - CIRCLE_PERCENT[label] * circleLength
                          : circleLength
                      }
                    ></circle>
                  ))}
                </g>
                {step >= 5 && step <= 7 && (
                  <g className={`circle-strokes-layers step-${step}`}>
                    {[1, 2, 3, 4].map((num, i) => (
                      <circle
                        key={`${num}a`}
                        className={`circle-stroke-layer stroke-${num} step-${step}`}
                        cx="0"
                        cy="0"
                        r="7.25vw"
                      ></circle>
                    ))}
                  </g>
                )}
                {/* <g className={`circle-nums step-${step}`}>
                  {[1, 2, 3, 4].map((num) => (
                    <text
                      key={`${num}b`}
                      className={`circle-num num-${num} num-${num}-step-${step}`}
                      x={0}
                      y={0}
                    >
                      {num}
                    </text>
                  ))}
                </g> */}
                <g className={`circle-labels`}>
                  {LABELS.map((label, i) => (
                    <text
                      key={label + 'a'}
                      className={`circle-label label-${i + 1} step-${step}`}
                      x={0}
                      y={0}
                    >
                      {label}
                    </text>
                  ))}
                </g>
              </>
            )}
          </svg>
        )}
        {step >= 3 && (
          <>
            <div className={`circle-nums step-${step}`}>
              {[1, 2, 3, 4].map((num) => (
                <div
                  key={`${num}b`}
                  className={`circle-num num-${num} num-${num}-step-${step}`}
                  // x={0}
                  // y={0}
                >
                  {num}
                </div>
              ))}
            </div>
            <div className={`gradient-bar step-${step}`} />
            <div className={`blue-step step-${step}`} />
            <div className={`green-step step-${step}`} />
            <div className={`pink-step step-${step}`} />
            <div className={`yellow-step step-${step}`} />
          </>
        )}
      </>
    </figure>
  )
}

export default StageIntro
